function hidden(galleryImageCount) {
  return (galleryImageCount === 1) ? 'hide' : '';
}

export default ({
  modalImageUri,
  modalImageRetinaUri,
  modalImageCount,
}) => `<div class="gallery-modal">
  <div class="grid grid--bleed">
    <div class="grid__inner">
      <div class="grid__item grid__item--tablet-up-6 text-center gutter-bottom">
        <img sizes="100vw" srcset="${modalImageUri}, ${modalImageRetinaUri}" class="gutter-bottom">

        <div class="${hidden(modalImageCount)}">
          <button type="button" class="gallery-button gallery-button--prev modal-nav-prev" aria-label="previous"><i class="gallery-caret gallery-caret--left"></i></button>
          <button type="button" class="gallery-button gallery-button--next modal-nav-next" aria-label="next"><i class="gallery-caret gallery-caret--right"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>`;
